<template>
    <div>
        <el-form ref="addForm" :model="addForm" :rules="rules" label-width="100px">
            <el-row>
                <el-col :span="6">
                    <el-form-item label="公司" prop="renterId" class="renterId">
                        <el-select v-model="addForm.renterId" placeholder="请选择" class="inputDiv" clearable
                            style="width:100%">
                            <el-option v-for="item in companyList" :key="item.renterId" :label="item.renterCompanyName"
                                :value="item.renterId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-row v-for="(item, index) in addForm.buildHose" :key="index">
                    <el-col :span="6">
                        <el-form-item label="楼宇" class="formItem"
                            :rules="{ required: true, message: '楼宇不能为空', trigger: 'blur' }"
                            :prop="'buildHose.' + index + '.buildId'">
                            <el-select v-model="item.buildId" placeholder="请选择" class="inputDiv" style="width:100%"
                                @change="(val) => handleBuilding(index, val)">
                                <el-option v-for="item1 in buildingList" :key="item1.id" :label="item1.buildingName"
                                    :value="item1.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="房屋" class="formItem"
                            :rules="{ required: true, message: '房屋不能为空', trigger: 'blur' }"
                            :prop="'buildHose.' + index + '.roomId'">
                            <el-select v-model="item.roomId" placeholder="请选择" class="inputDiv" style="width:100%">
                                <el-option v-for="item1 in item.roomList" :key="item1.roomId" :label="item1.roomName"
                                    :value="item1.roomId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="2" style="line-height:50px;text-align:center">
                        <i class="el-icon-circle-plus-outline" @click="addBuildHouse" v-if="index == 0"></i>
                        <i class="el-icon-remove-outline" @click="removeBuildHouse(index)" v-if="index != 0"></i>
                    </el-col>
                </el-row>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="纳税周期" prop="time" class="formItem">
                        <el-date-picker v-model="addForm.time" value-format="yyyy-MM-dd" type="daterange"
                            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="纳税金额" prop="taxAmount" class="formItem">
                        <el-input-number v-model="addForm.taxAmount" :min="1" :max="99999" label="描述文字">
                        </el-input-number>  元
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="关联合同" prop="contractId" class="formItem">
                        <el-select v-model="addForm.contractId" multiple placeholder="请选择" @change="handleContractId">
                            <el-option v-for="item in contractList" :key="item.contractList" :label="item.contractName"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6">
                    <el-form-item label="联系人" prop="contactPerson" class="formItem">
                        <el-input v-model="addForm.contactPerson" clearable placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6">
                    <el-form-item label="联系电话" prop="contactPhone" class="formItem">
                        <el-input v-model="addForm.contactPhone" clearable placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="附件上传" prop="" class="formItem">
                        <uploadFile @handleFile="handleFile" :attachmentUrlList="addForm.attchmentUrl"
                            :isFileType="['file']"></uploadFile>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align:center">
            <el-button @click="closeData">返回</el-button>
            <el-button type="primary" @click="addEventForm()">保 存</el-button>
        </div>
    </div>
</template>
<script>
import { Message } from 'element-ui'
import { baseRenterCompany, queryBuilding, baseRoomInfo } from '@/api/basicInfo'
import { contractQuery, baseVoucher } from '@/api/contract'
import { validPhone } from "@/assets/scripts/validate";
import uploadFile from '../../components/upload/uploadFile.vue';
export default {
    components: {
        uploadFile
    },
    data() {
        return {
            edit: false,
            passwordForm: {},
            addForm: {
                renterId: '', // 承租id
                taxBegin: '', // 纳税周期开始
                taxEnd: '', // 纳税周期结束
                taxAmount: '', // 纳税金额
                contractId: [], // 关联合同
                contractName: [], // 关联合同
                contactPerson: '', // 关联合同
                contactPhone: '', // 联系电话
                attchmentUrl: '', // 附件上传
                time: [],
                buildHose: [{
                    buildId: '',
                    roomId: '',
                    roomList: [],
                }],
            },
            rules: {
                renterId: [{ required: true, message: '请填写', trigger: 'blur' }],
                time: [{ required: true, message: '请选择', trigger: 'blur' }],
                taxAmount: [{ required: true, message: '请填写', trigger: 'blur' }],
                contractId: [{ required: true, message: '请选择', trigger: 'blur' }],
                contactPerson: [
                    { required: true, message: '请填写', trigger: 'blur' },
                ],
                contactPhone: [{ required: true, message: '请填写', trigger: 'blur' }, { validator: validPhone, trigger: 'blur' }],
            },
            companyList: [],
            buildingList: [],
            contractList: [],
            isEdit: true,
        }
    },
    mounted() {
        this.isEdit = this.$route.query.isEdit
        this.Lists()
    },
    methods: {
        async Lists() {
            // 获取公司
            const { result } = await baseRenterCompany('query', {
                pageNum: 1,
                pageSize: 999
            })
            this.companyList = result.records
            // 获取楼栋
            let res = await queryBuilding({
                pageNum: 1,
                pageSize: 999
            })
            this.buildingList = res.result.records
            // 获取合同
            let res1 = await contractQuery({
                pageNum: 1,
                pageSize: 999,
                contractStatus: 7, // 审批通过
                buildingId: "",
                companyId: "",
                contractName: "",
                contractNumber: ""
            })
            this.contractList = res1.result.records
            if (this.$route.query.isEdit === 'edit') {
                let res2 = await baseVoucher('getDetail', {
                    id: this.$route.query.id
                })
                this.newOldFormContrast(res2.result)
            }
        },
        addBuildHouse() {
            this.addForm.buildHose.push({
                buildId: '',
                roomId: '',
                roomList: []
            })
        },
        async handleBuilding(index, val) {
            this.addForm.buildHose[index].roomList = []
            this.addForm.buildHose[index].roomId = ''
            let res = await baseRoomInfo('query', {
                pageNum: 1,
                pageSize: 999,
                buildingId: val
            })
            this.addForm.buildHose[index].roomList = res.result.records
        },
        removeBuildHouse(index) {
            this.addForm.buildHose.splice(index, 1)
        },
        // 选择合同  通过id获取name
        handleContractId(val) {
            this.addForm.contractName = (this.contractList.filter(v => val.some(id => id === v.id))).map(v1 => v1.contractName) || []
        },
        handleFile(imgs) {
            let arrFile = imgs.map(v => v.code).join(',')
            this.addForm.attchmentUrl = arrFile
        },
        newOldFormContrast(newForm) {
            Object.keys(this.addForm).forEach(key => {
                this.addForm[key] = newForm[key]
            })
            this.addForm.id = newForm.id
            this.addForm = {
                ...this.addForm,
                contractId: this.addForm.contractId.split(',').map(v => Number(v)),
                contractName: this.addForm.contractName.split(','),
                time: [newForm.taxBegin, newForm.taxEnd],
            }
            let arr = []
            newForm.roomInfoEntityList.map(async (v, index) => {
                    const { result } = await baseRoomInfo('query', {
                        pageNum: 1,
                        pageSize: 999,
                        buildingId: v.buildingId
                    })
                    arr.push({
                        roomList: result.records,
                        buildId: v.buildingId,
                        roomId: v.roomId
                   })
                // console.log(arr);
            })
            setTimeout(() => {
                this.addForm.buildHose = arr
            }, 1000)
            // console.log(this.addForm, 'this.addFormthis.addFormthis.addForm');
        },
        closeData() {
            this.$router.push('/contract/taxManagement')
        },
        addEventForm() {
            let newObj = JSON.parse(JSON.stringify(this.addForm))
            newObj.renterCompanyName = newObj.renterId ? (this.companyList.find(v => v.renterId === newObj.renterId)).renterCompanyName : ''
            newObj.contractId = newObj.contractId ? newObj.contractId.join(',') : ''
            newObj.contractName = newObj.contractName ? newObj.contractName.join(',') : ''
            newObj.roomId = newObj.buildHose ? newObj.buildHose.map(v => v.roomId).join(',') : ''
            newObj.taxBegin = newObj.time ? newObj.time[0] : ''
            newObj.taxEnd = newObj.time ? newObj.time[1] : ''
            delete newObj.time
            delete newObj.buildHose
            console.log(newObj, '111');
            console.log(this.addForm, '222');
            console.log(this.isEdit, '333');
            this.$refs['addForm'].validate(async (valid) => {
                if (valid) {
                    if (this.isEdit === 'edit') {
                        let res = await baseVoucher('update', newObj)
                        if (res.code === 0) {
                            Message.success('编辑成功！')
                            this.closeData()
                            await this.getData()
                        } else {
                            Message.warning({ message: res.message })
                        }
                    } else {
                        let res = await baseVoucher('add', newObj)
                        if (res.code === 0) {
                            Message.success('新增成功！')
                            this.closeData()
                            await this.getData()
                        } else {
                            Message.error(res.message)
                        }
                    }
                }
            })
        },
    }
}
</script>
<style>
.el-icon-circle-plus-outline,
.el-icon-remove-outline {
    margin-left: 10px;
    font-size: 20px;
    cursor: pointer;
}
</style>